import { render, staticRenderFns } from "./CalendarReservationsSimple.vue?vue&type=template&id=005fc053"
import script from "./CalendarReservationsSimple.vue?vue&type=script&lang=js"
export * from "./CalendarReservationsSimple.vue?vue&type=script&lang=js"
import style0 from "./CalendarReservationsSimple.vue?vue&type=style&index=0&id=005fc053&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports